import React, { Component } from "react"
import Icon from "react-icons-kit"
import { Segment, Label, Button, Grid, Image } from "semantic-ui-react"
import "./PourquoiNous.css"
import GainDargent from "../../../assets/LandingPageMTP/Economie_Argent.png"
import Complet from "../../../assets/LandingPageMTP/Complet.png"
import GainDeTemps from "../../../assets/LandingPageMTP/Gain_de_Temps.png"

class PourquoiNous extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <Segment id="blocPourquoiNous">
        {" "}
        <Segment id="blocTitle">
          <h1 id="titlePourquoiNous">POURQUOI NOUS</h1>
          <h2 id="titlePourquoiNous">Lorem ipsum dolor sit amet</h2>
          <p id="titlePourquoiNous">
            Itaque tum Scaevola cum in eam ipsam mentionem incidisset{" "}
          </p>
        </Segment>
        <Grid columns="equal" id="gridPourquoiNous">
          <Grid.Column id="blocColumn">
            <Image src={Complet} id="imagePourquoiNous" />
            <h2>COMPLET</h2>
            <div id="paragraphePourquoiNous">
              MYTRAVO est une application complète avec plus d'une trentaine de
              travaux, un référentiel de plus de 10 000 produits, des listes de
              courses, un scanner pour obtenir des informations produits et même
              une règle et un niveau à bulle !
            </div>
          </Grid.Column>
          <Grid.Column id="blocColumn">
            <Image src={GainDeTemps} id="imagePourquoiNous" />
            <h2>GAIN DE TEMPS</h2>
            <p id="paragraphePourquoiNous">
              Mettez rapidement et simplement vos besoins en matériaux et
              matériels dans votre liste de courses. Fini les allers-retours en
              magasin.
            </p>
          </Grid.Column>
          <Grid.Column id="blocColumn">
            <Image src={GainDargent} id="imagePourquoiNous" />
            <h2>ECONOMIE D'ARGENT</h2>
            <p id="paragraphePourquoiNous">
              Maîtriser votre budget en listant et en calculant en toute
              simplicité les matériaux nécessaires à la réalisation de vos
              projets. Plus d'achat inutil !
            </p>
          </Grid.Column>
        </Grid>
      </Segment>
    )
  }
}

export default PourquoiNous



// WEBPACK FOOTER //
// ./src/components/Pro/AcceuilLandingPage/PourquoiNous.js